import { define } from 'wicked-elements'

define('[data-component~="rich-text"]', {
  init() {
    this.formatWpImages()
    this.formatCmoaImages()
    this.formatGroups()
    this.loadedImages = []
    this.resizeTimer = null
    this.handleResize = this.handleResize.bind(this)
    this.handleImageLoad = this.handleImageLoad.bind(this)
  },
  connected() {
    window.addEventListener('resize', this.handleResize)
    document.addEventListener('lazyloaded', this.handleImageLoad)
  },
  disconnected() {
    window.removeEventListener('resize', this.handleResize)
    document.removeEventListener('lazyloaded', this.handleImageLoad)
  },
  /**
   * Sets orientation class on wp-caption
   */
  formatWpImages() {
    const figures = [...this.element.querySelectorAll('.wp-caption')]
    figures.forEach((figure) => {
      const image = figure.querySelector('img')
      this.setOrientation(image, figure)
    })
  },
  /**
   * Sets orientation class on cmoa-image
   */
  formatCmoaImages() {
    const figures = [...this.element.querySelectorAll('.cmoa-image')]
    figures.forEach((figure) => {
      const image = figure.querySelector('img')
      this.setOrientation(image, figure)
    })
  },
  /**
   * Sets orientation based on width/height attributes
   */
  setOrientation(image, figure) {
    let width = parseInt(image.getAttribute('width'))
    let height = parseInt(image.getAttribute('height'))

    // If we have width & height from attributes, immediatly set
    if (width && height) {
      let orientation = height >= width ? 'portrait' : 'landscape'
      figure.classList.add(`orientation-${orientation}`)
    }
  },
  /**
   * Sets orientation based on calculated width/height
   */
  setOrientationAction(image, figure) {
    let width = image.width
    let height = image.height
    let orientation = height >= width ? 'portrait' : 'landscape'
    figure.classList.add(`orientation-${orientation}`)
  },
  /**
   * On image (lazy)load, we limit the image, set orientation
   * and add it to the loaded images array
   */
  handleImageLoad(e) {
    const image = e.target
    const figure = image.closest('.wp-caption')
    if (image && figure) {
      this.limitImageAction(image, figure)
      this.setOrientationAction(image, figure) // Just in case the orientation wasn't caught initially
      this.loadedImages.push([image, figure])
    }
  },
  /**
   * We have removed width styles from the WP output. Instead,
   * we use JS to set the width of wp-caption on resize with js.
   * This gives us consistent behavior across images with/without
   * captions, and doesn't set massive widths for large images.
   */
  limitImages() {
    this.loadedImages.forEach(([image, figure]) => {
      this.limitImageAction(image, figure)
    })
  },
  limitImageAction(image, figure) {
    figure.style.removeProperty('width')
    setTimeout(() => {
      figure.style.width = image.width + 'px'
    }, 10)
  },
  /**
   * Rather than limiting image directly on the resize event,
   * do it on resize-complete
   */
  handleResize() {
    clearTimeout(this.resizeTimer)
    this.resizeTimer = setTimeout(() => {
      this.limitImages()
    }, 100)
  },
  /**
   * Wrap h2/h3 groups to avoid break-inside. Either format the entire
   * container, or parse for columns shortcodes
   */
  formatGroups() {
    if (this.element.hasAttribute('data-format-groups')) {
      this.createGroups(this.element)
    } else {
      const columnsShortcodes = Array.from(
        this.element.querySelectorAll('.sc-columns')
      )
      columnsShortcodes.forEach((el) => {
        this.createGroups(el)
      })
    }
  },
  createGroups(container) {
    const children = Array.from(container.children)
    const headers = children.filter(
      (child) => child.tagName === 'H3' || child.tagName === 'H4'
    )

    if (headers.length <= 1) {
      return
    }

    let group = null

    children.forEach((child) => {
      if (child.tagName === 'H3' || child.tagName === 'H4') {
        if (group) {
          container.insertBefore(group, child)
        }
        group = document.createElement('div')
        group.className = 'rich-text break-inside-avoid'
      }
      if (group) {
        group.appendChild(child)
      }
    })

    if (group) {
      container.appendChild(group)
    }
  },
})
